import { Offer } from 'dealer-types'
import React, { useMemo } from 'react'
import VehicleTitle from './offer/VehicleTitle'
import Space from 'src/components/atoms/Space'
import SellSection from './offer/SellSection'
import PublishedTimeAgo from 'src/components/atoms/PublishedTimeAgo'
import View from '../atoms/View'
import Text from '../atoms/TextNew'
import BuyNowModal from './offer/BuyNowModal'
import AuctionContractModal from './offer/AuctionContractModal'
import GallerySection from './GallerySection'
import { useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
interface Props {
  offer: Offer
}

const OfferTopSection = ({ offer }: Props): JSX.Element => {
  const dealerLanguage = useSelector((state: RootReducer) => state.userDataReducer.default_language_code)

  const frameSrc = useMemo(() => {
    if (offer.lat !== null && offer.long !== null) {
      return (
        'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d500000' +
        `!2d${offer.long === null ? '' : offer.long}!3d${offer.lat === null ? '' : offer.lat}` +
        '!2m3!1f0!2f0!3f0!m2!1i1024!2i768!4f13.1!5e0' +
        `!3m2!1s${dealerLanguage}!2s${dealerLanguage}` +
        `!4v1741350687164!5m2!1s${dealerLanguage}!2s${dealerLanguage}`
      )
    }
    return `https://www.google.com/maps?q=${offer.zip_code}+${offer.place}+${
      offer.country_code ?? ''
    }&output=embed&hl=${dealerLanguage}`
  }, [offer.lat, offer.long, dealerLanguage, offer.zip_code, offer.place, offer.country_code])
  return (
    <>
      <Space y={2} />
      <div className="flex gap-6 h-[520px]">
        <div className="flex-1">
          <GallerySection photos={offer.photos} />
        </div>
        <div className="w-[347px] flex flex-col relative overflow-hidden">
          <BuyNowModal />
          <AuctionContractModal />
          <VehicleTitle
            label1={offer.vehicle?.label1}
            label2={offer.vehicle?.label2}
            offerHashId={offer.hash_id}
            zipCode={offer.zip_code}
            place={offer.place}
            countryCode={offer.country_code}
            vehicleType={offer.vehicle_type}
            vehicle={offer.vehicle}
          />
          <Space y={2} />
          <div className="flex-1">
            <iframe
              src={frameSrc}
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '10px' }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <Space y={2} />
          {!offer.closed && (
            <SellSection
              buyNowPrice={offer.buy_now_contract?.price ?? 0}
              highestBet={offer.highest_bet_value}
              yourHighest={offer.my_bet_value ?? 0}
              minimalPrice={offer.minimal_price ?? 0}
              offerId={offer.id}
            />
          )}
          <Space y={4} />
          <View className="flex justify-between">
            <Text className="text-l font-Bold uppercase">{offer.hash_id}</Text>
            <PublishedTimeAgo publishedAt={offer.published_at} />
          </View>
        </div>
      </div>
    </>
  )
}

export default OfferTopSection
